import { colorSchemeVariable, themeQuartz } from 'ag-grid-community';

/**
 * AG Grid theme that inherits the app's CSS custom properties.
 * Automatically follows light/dark mode because it uses var(--...) references.
 * No computed signal needed — one theme for all modes.
 */
export const agGridAppTheme = themeQuartz.withPart(colorSchemeVariable).withParams({
  accentColor: 'var(--ds-surface-action-primary-filled)',
  backgroundColor: 'var(--ds-surface-base)',
  foregroundColor: 'var(--ds-text-primary)',
  borderColor: 'var(--ds-border-default)',
  headerBackgroundColor: 'var(--ds-surface-raised)',
  oddRowBackgroundColor: 'var(--ds-surface-base)',
  chromeBackgroundColor: 'var(--ds-surface-sunken)',
  sideBarBackgroundColor: 'var(--ds-surface-raised)',
  rowHoverColor: 'var(--ds-surface-action-muted-hover)',
  selectedRowBackgroundColor: 'var(--ds-surface-selected)',

  // Focused and editing cells share the same 1px --ds-border-focus border; no
  // elevated card shadow while editing. cellEditingBorder is emitted as one
  // border shorthand, so its color must be a token defined in every build —
  // an unresolvable var() kills the whole border.
  rangeSelectionBorderColor: 'var(--ds-border-focus)',
  cellEditingShadow: 'none',
  cellEditingBorder: 'solid 1px var(--ds-border-focus)',

  // Context/column menu popup — align with the soft-ds-context-menu surface.
  // Item hover, disabled text, and shortcut styling that these params don't
  // cover are set in the global styles/components/_ag.css override (the menu
  // renders at document root, beyond any component's ::ng-deep reach).
  menuBackgroundColor: 'var(--ds-context-menu-surface)',
  menuTextColor: 'var(--ds-context-menu-item-text)',
  menuSeparatorColor: 'var(--ds-context-menu-divider-color)',
  menuShadow: 'var(--ds-context-menu-shadow)',

  fontFamily: 'inherit',
  fontSize: 13,
  headerFontSize: 13,
  headerFontWeight: 600,
  borderRadius: 0,
  cellHorizontalPaddingScale: 0.8,

  // Toggle buttons (e.g. the pivot-mode switch) — match soft-ds-switch (md).
  toggleButtonWidth: 'var(--ds-switch-track-width-md)',
  toggleButtonHeight: 'var(--ds-switch-track-height-md)',
  toggleButtonOffBackgroundColor: 'var(--ds-switch-track-surface)',
  toggleButtonOnBackgroundColor: 'var(--ds-switch-track-surface-checked)',
  toggleButtonSwitchBackgroundColor: 'var(--ds-switch-thumb-surface)',
  toggleButtonSwitchInset: 'var(--ds-switch-track-padding)',
});
